import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faSquareFacebook,
    faSquareInstagram,
    faGooglePlay,
    faWhatsapp
} from "@fortawesome/free-brands-svg-icons";

function Footer() {
    return (
        <footer className="footer bg-white border-top">
            {/* Top Section */}
            <div className="container text-center py-4 py-md-5">
                <h1
                    className="fw-bold text-secondary mb-3 mb-md-4"
                    style={{ fontSize: 'clamp(1.8rem, 6vw, 3rem)', opacity: 0.6 }}
                >
                    By Celer
                </h1>

                <div className="mb-3">
                    <p className="mb-1 text-secondary small">Celer Commerce Pvt Ltd</p>
                    <p className="mb-0 text-secondary small">© 2025 All rights reserved</p>
                </div>

                <div className="mb-3 text-secondary small">
                    Made with <span className="text-danger">❤️</span> in India
                </div>

                <div className="mb-2 text-secondary" style={{ fontSize: 'clamp(0.8rem, 2vw, 0.95rem)' }}>
                    <span className="mx-2">Fast Delivery</span> •
                    <span className="mx-2">Best Prices</span> •
                    <span className="mx-2">Quality Products</span>
                </div>
                <div className="text-muted" style={{ opacity: 0.5, fontSize: 'clamp(0.72rem, 1.5vw, 0.8rem)' }}>
                    Version 1.0.3
                </div>
            </div>

            {/* Bottom Section */}
            <div className="bg-light py-3 border-top">
                <div
                    className="container d-flex flex-wrap justify-content-center align-items-center gap-2 gap-md-3 text-secondary"
                    style={{ fontSize: 'clamp(0.78rem, 2vw, 0.9rem)' }}
                >
                    <span className="text-center">&copy; Celer Commerce Private Limited, 2025-2026</span>

                    <span className="d-none d-md-block mx-1">|</span>

                    <a
                        href="https://play.google.com/store/apps/details?id=celer.te.prod1&pcampaignid=web_share"
                        className="fw-bold d-flex align-items-center gap-2 text-dark text-decoration-none hover-opacity"
                        style={{ minHeight: 36 }}
                    >
                        Download App
                        <FontAwesomeIcon icon={faGooglePlay} size="lg" className="bg-dark text-light p-1 rounded-1" />
                    </a>

                    <span className="d-none d-md-block mx-1">|</span>

                    <div className="d-flex align-items-center gap-3">
                        <a
                            href="https://www.facebook.com/profile.php?id=61577874014425"
                            className="text-dark hover-opacity d-flex align-items-center justify-content-center"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ minWidth: 36, minHeight: 36 }}
                        >
                            <FontAwesomeIcon icon={faSquareFacebook} size="xl" />
                        </a>
                        <a
                            href="https://www.instagram.com/celer._in/"
                            className="text-dark hover-opacity d-flex align-items-center justify-content-center"
                            target="_blank"
                            rel="noreferrer"
                            style={{ minWidth: 36, minHeight: 36 }}
                        >
                            <FontAwesomeIcon icon={faSquareInstagram} size="xl" />
                        </a>
                        <a
                            href="https://whatsapp.com/channel/0029Vb5fNYHC1FuFX5faSt0s"
                            className="text-dark hover-opacity d-flex align-items-center justify-content-center"
                            target="_blank"
                            rel="noreferrer"
                            style={{ minWidth: 36, minHeight: 36 }}
                        >
                            <FontAwesomeIcon icon={faWhatsapp} size="xl" />
                        </a>
                    </div>
                </div>
            </div>

            <style>{`
                .hover-opacity:hover { opacity: 0.7; transition: opacity 0.2s; }
            `}</style>
        </footer>
    );
}

export default Footer;
